import db from './mutations-db';

export default async function pendingSyncPackages() {
  const pendingPackageMutations = await db.getPendingPackageMutations();
  return pendingPackageMutations.length;
}
